import React, {useCallback, useEffect, useState} from 'react';
import {Input, Popup} from "semantic-ui-react";
import debounce from "lodash.debounce";
import DualRangeSlider from "../../components/DualRangeSlider";
import SvgNew from "../../components/SvgNew";
import ClearableInput from "../../components/Input/ClearableInput";
import {getSelectOptions} from "../api";
import {isNumber} from "../../services/utils";
import {settingsWithoutThis} from "../utils";

const NumberFilter = ({filter, column, setFilter, unit, filterParams}) => {

    const changeFilter = (v) => {
        setFilter({
            fieldName: column.fieldName,
            operation: 'between',
            value: (v && (v[0] || v[1])) ? v.toString() : null
        })
    }

    const style = {
        border: '1px solid #135CA9',
        padding: '12px',
        borderRadius: '4px'
    }

    const getValue = (i) => {
        return ((filter || {}).value || '').split(',')[i];
    }

    const [v1, setV1] = useState(getValue(0));
    const [v2, setV2] = useState(getValue(1));

    const [min, setMin] = useState(null);
    const [max, setMax] = useState(null);

    useEffect(() => {
        !v1 && setV1(getValue(0))
        !v2 && setV2(getValue(1))
    }, [filter]);

    useEffect(() => {
        if (v1 && ((v1 > max) || (v1 < min))) setV1(min)
        if (v2 && ((v2 > max) || (v2 < min))) setV2(max)
    }, [min, max]);

    const setValues = (v1, v2) => {
        changeFilter([v1, v2]);
    }

    const getSelectOpts = (column, filterParams) => {
        getSelectOptions(column.fieldName, filterParams).then(v => {
            setMin(Math.floor(v.minValue))
            setMax(Math.ceil(v.maxValue))
        })
    }

    const getSelectOptionsDebounce = useCallback(debounce(getSelectOpts, 2000), []);

    useEffect(() => {
        getSelectOptionsDebounce(column, settingsWithoutThis(filterParams, column.fieldName))
    }, [column, filterParams]);

    // useEffect(() => {
    //     (v1 || v2) && setFilterValues(v1, v2)
    // }, [v1, v2])
    //
    // const setFilterValues = useCallback(debounce(setValues, 1000), []);

    return (
        <Popup
            onClose={() => setValues(v1, v2)}
            style={style}
            on='click'
            basic
            position='bottom left'
            pinned
            trigger={
                <ClearableInput
                    readOnly
                    withSort={true}
                    sizer={true}
                    compact
                    onChange={(e, {value}) => {
                        setV1(null);
                        setV2(null);
                        changeFilter(value)
                    }}
                    value={(v1 || v2) ? `${isNumber(v1) ? v1 : (isNumber(min) ? min : '')} — ${isNumber(v2) ? v2 : (isNumber(max) ? max : '')}${unit ? `, ${unit}` : ''}` : ''}
                    placeholder={column.title}
                />
            }
        >
            <div className='filter-inputs'>
                <Input
                    type='number'
                    value={isNumber(v1) ? v1 : ''}
                    min={min}
                    max={v2}
                    onChange={(e, {value}) => setV1(Math.min(value, max || value))}
                />
                <SvgNew name='dash'/>
                <Input
                    type='number'
                    value={isNumber(v2) ? v2 : ''}
                    min={v1}
                    max={max}
                    onChange={(e, {value}) => setV2(Math.min(value, max || value))}
                />
            </div>
            {(min || max) ? <DualRangeSlider
                v1={v1}
                v2={v2}
                max={max}
                min={min}
                onChange={({min, max}) => {
                    setV1(min);
                    setV2(max);
                }}
            /> : null}
        </Popup>
    );
};

export default NumberFilter;


// WEBPACK FOOTER //
// ./App/grids/filters/number.jsx